module.exports = __webpack_public_path__ + "static/ZMT_Dubai-20f0eb7cffadea8477b90069d658dee9.mp4";